module.exports = __webpack_public_path__ + "img/digest.9ded9e76.svg";